import { render, staticRenderFns } from "./Customizer.vue?vue&type=template&id=4e8c6ed5&scoped=true&"
import script from "./Customizer.vue?vue&type=script&lang=js&"
export * from "./Customizer.vue?vue&type=script&lang=js&"
import style0 from "./Customizer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Customizer.vue?vue&type=style&index=1&id=4e8c6ed5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c6ed5",
  null
  
)

export default component.exports